import * as React from 'react';
import * as style from './SubAccounts.css';

import { Position } from '../Position';
import { useDeviceType } from '@cian/ui-kit';
import classnames from 'classnames';
import { MAX_POSITION_SHOWS, MIN_POSITION_SHOWS } from './constants';
import { IAgencyAccount } from '../../../common/types/rating';

type TSubAccountsProps = {
  list: IAgencyAccount[];
};

export const SubAccounts: React.FC<TSubAccountsProps> = ({ list }) => {
  const devicePhone = useDeviceType() === 'phone';

  return (
    <div className={classnames(style['subaccounts-container'], devicePhone && style['subaccounts-container-mobile'])}>
      <p className={style['list-title']}>
        <span className={style['same-color-accent']}>{list.length >= 5 ? 'Топ-5 филиалов:' : 'Филиалы:'}</span>
      </p>
      <div className={style['list']}>
        {list.map(
          ({ shows, posShows, url, agencyname, changePosition }, index) =>
            posShows < MAX_POSITION_SHOWS &&
            shows > MIN_POSITION_SHOWS && (
              <div className={style['item']} key={index}>
                <Position showsPosition={posShows} positionChange={changePosition} />
                <div className={style['item-column']}>
                  <a href={url} className={style['link']} target="_blank" rel="noreferrer">
                    {agencyname}
                  </a>
                </div>
                <div className={style['item-column']}>{(shows / 1000000).toFixed(3)}</div>
              </div>
            ),
        )}
      </div>
    </div>
  );
};
